export default __webpack_public_path__ + "static/media/full_black.10143121.svg";